import type { Feed, FeedEntry, UIComponent } from '~/services/layout/index.ts';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import manifest from '../config/manifest.ts';
import logger from '~/services/logger/index.ts';
import { twMerge } from 'tailwind-merge';
import { getComponentMarginsOnMaxWidth } from '~/utils/styles.ts';
import { WEBVIEW_IFRAME_SANDBOX } from '~/utils/iframe-sandbox.ts';

export default function WebviewComponent({
  uiComponent,
  feed,
}: {
  uiComponent: UIComponent;
  feed?: Feed;
}): JSX.Element {
  const config = getPluginConfig<typeof manifest>(manifest, uiComponent);

  const {
    general: { webview_accessibility_title, url },
    styles,
  } = config;

  const { webview_height_type } = styles;

  try {
    const firstEntry: FeedEntry | undefined = feed?.entry?.[0];

    const src = firstEntry?.link?.href || url;

    if (!src) return <></>;

    return (
      <section
        className={twMerge(
          `component-${uiComponent.id} component-classes relative w-full overflow-hidden border-none`,
          getComponentMarginsOnMaxWidth({ styles }),
          'component-maximum-width',
          !webview_height_type && 'h-webview',
          webview_height_type === 'custom' && 'h-webview',
          webview_height_type === 'screen_height' && 'h-screen'
        )}
      >
        <iframe
          title={webview_accessibility_title || 'iframe'}
          allowFullScreen={true}
          sandbox={WEBVIEW_IFRAME_SANDBOX}
          src={src}
          className="h-full w-full"
        />
      </section>
    );
  } catch (error: any) {
    logger.info(`Webview component: ${error.message}`);
    return <></>;
  }
}
